import React, { useState } from "react";
import { Linkedin, MessageCircle, Link2, Check, Twitter } from "lucide-react";
import { API_BASE } from "../api";

export const shareUrl = (kind, slug) => `${API_BASE}/api/s/${kind}/${slug}`;

export const ShareBar = ({ kind, slug, title, compact = false }) => {
  const [copied, setCopied] = useState(false);
  const url = shareUrl(kind, slug);
  const enc = encodeURIComponent;
  const links = [
    { label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc(`${title} ${url}`)}`, testid: "share-whatsapp" },
    { label: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`, testid: "share-linkedin" },
    { label: "X", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${enc(title)}&url=${enc(url)}`, testid: "share-x" },
  ];
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {}
  };
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-bar">
      {!compact && <span className="text-sm font-medium text-[var(--fr-muted)] mr-1">Share</span>}
      {links.map(({ label, icon: Icon, href, testid }) => (
        <a key={label} href={href} target="_blank" rel="noreferrer" className="icon-btn" title={`Share on ${label}`} aria-label={`Share on ${label}`} data-testid={testid}>
          <Icon size={15} />
        </a>
      ))}
      <button type="button" onClick={copy} className="icon-btn" title="Copy link" aria-label="Copy link" data-testid="share-copy">
        {copied ? <Check size={15} className="text-emerald-600" /> : <Link2 size={15} />}
      </button>
      {copied && <span className="text-xs text-emerald-700" data-testid="share-copied">Link copied</span>}
    </div>
  );
};

export default ShareBar;
